// extracted by mini-css-extract-plugin
export default {"canvasBackground":"BackgroundAnimation_canvasBackground__uG2v9"};